import './bootstrap';


window.initAlpine = () => {
  return {
    question: 1,
    isLoading: false,
    answers: [],
    email: null,
    name: null,
    area: null,
    age: null,
    tel1: null,
    tel2: null,
    tel3: null,
    agreement: false,
    errors: {},
    isQuestion(page) {
      return this.question === page;
    },
    isShowPrevious() {
      return this.question > 1 && this.question < 6;
    },
    selectAnswer(page, value) {
      this.answers[page - 1] = value;
      this.question++;
    },
    previous() {
      this.question--;
      this.answers[this.question - 1] = null;
    },
    hasError(key) {
      return this.errors[key];
    },
    getError(key) {
      return (this.errors[key] || [])[0];
    },
    clearError(key) {
      delete this.errors[key];
    },
    async submitAlpine() {
      if (this.isLoading) return;
      this.isLoading = true;

      this.errors = {};

      let response = await (await fetch('/contact', {
        method: 'POST',
        body: JSON.stringify({
          answers: this.answers,
          email: this.email,
          name: this.name,
          area: this.area,
          age: this.age,
          agreement: this.agreement ? true : null,
          tel: "" + (this.tel1 || "") + (this.tel2 || "") + (this.tel3 || ""),
          _token: document.head.querySelector('meta[name=csrf-token]').content,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })).json();
      this.isLoading = false;

      if (response.message === 'CSRF token mismatch.') {
        this.errors = {other: ['セッションの時間切れです。再読み込みした上で登録してください。']}
        return;
      }

      if (response.errors) {
        this.errors = response.errors;
        return;
      }

      if (response.status === 'success') {
        this.$nextTick(() => {
          document.getElementById('completed_email').value = this.email;
          document.forms["form-completed"].submit();
        });
      } else {
        this.errors = {other: ['登録に失敗しました。再読み込みした上で再度登録してください。']}
      }
    }
  }
}